import * as types from './types'

const mutations = {
  [types.SET_LIST] (state, payload) {
    state.list = payload
  },
  [types.SET] (state, payload) {
    state.record = payload
  },
  [types.SET_TIMELINE] (state, payload) {
    state.record = { ...state.record, timeline: payload }
  },
  [types.UNSET] (state) {
    state.record = {
      address: {},
      timeline: []
    }
  }
}

export default mutations
